import { atom, useAtom } from "jotai";
import { useCallback } from "react";

import { SlideOverInputOptions } from "./useValidInputProps";

type OpenOptions = SlideOverInputOptions & {
  /** Close once the sync is created instead of showing the success view; a webhook still shows it, for its URLs. */
  closeOnCreate?: boolean;
};

const slideOverOpenState = atom<{ isOpen: boolean } & OpenOptions>({
  isOpen: false,
});

export function useDataSourceSlideOver() {
  const [state, setState] = useAtom(slideOverOpenState);
  return {
    state,
    onOpen: useCallback(
      (options?: OpenOptions) => {
        setState({
          isOpen: true,
          ...(options ?? {}),
        });
      },
      [setState],
    ),
    onClose: useCallback(() => {
      setState({
        isOpen: false,
      });
    }, [setState]),
  };
}
